import { DestroyRef, Injectable, inject } from '@angular/core';
import { AppResumeLifecycleService, ResumeReason } from '../lifecycle/app-resume-lifecycle.service';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SentryLogger } from '@lentau/core/sentry/shared/services/sentry-logger.service';
import { ErrorLevel } from '@lentau/core/sentry/shared/services/sentry.level.const';
import { ServiceWorkerUpdateService } from '@lentau/core/service-worker/application/sw.update.service';
import { ClientReloadPolicyService } from '../config/client-reload-policy.service';

// Проверяет, нужно ли обновлять сервис-воркер при возобновлении приложения из фона
@Injectable({
  providedIn: 'root',
})
export class SwResumeHealthcheckService {
  private readonly appResumeLifecycleService: AppResumeLifecycleService = inject(AppResumeLifecycleService);
  private readonly sentryLogger: SentryLogger = inject(SentryLogger);
  private readonly serviceWorkerUpdateService: ServiceWorkerUpdateService = inject(ServiceWorkerUpdateService);
  private readonly clientReloadPolicyService: ClientReloadPolicyService = inject(ClientReloadPolicyService);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  private isInitialized: boolean = false;

  public init(): void {
    if (this.isInitialized) {
      return;
    }

    this.isInitialized = true;

    this.appResumeLifecycleService.onResume$
      .pipe(
        filter((reason: ResumeReason | null): reason is ResumeReason => reason !== null),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((reason: ResumeReason) => {
        if (!this.clientReloadPolicyService.isSwResumeEnabled()) {
          return;
        }

        const minimumBackgroundDurationMs: number = this.clientReloadPolicyService.getSwResumeMinBackgroundMs();
        const backgroundDurationMs: number | null = this.appResumeLifecycleService.getLastBackgroundDurationMs();

        if (backgroundDurationMs === null || backgroundDurationMs < minimumBackgroundDurationMs) {
          return;
        }

        void this.sentryLogger.handleError('App resumed, running SW update health-check', ErrorLevel.INFO, {
          backgroundDurationMs,
          reason,
        });
        void this.serviceWorkerUpdateService.update(`resume:${reason}`);
      });
  }
}
